import { getEnumValues } from './get-enum-values';
export enum GradeName{
	Approaching="Approaching",
	Meets="Meets",
	Exceeds="Exceeds",
}
export const GradeNameValues = getEnumValues<GradeName>(GradeName);
